import { MOCK_TEST_TYPE } from '@app/constants/mockTest';
import { TFunction } from 'i18next';

export const BREAK_INDEXES = [2, 4];

export const fullTestData = (t: any) => [
  {
    key: 1,
    part: t('page.mockTest.intro.intro'),
    content: t('page.mockTest.intro.intro'),
    time: `1 ${t('page.mockTest.intro.minute')}`,
  },
  {
    key: 2,
    part: `${t('page.mockTest.intro.part')} 1`,
    content: t('page.mockTest.intro.speakAndWrite'),
    time: `54-67 ${t('page.mockTest.intro.minutes')}`,
  },
  { key: 3, time: `2 ${t('page.mockTest.intro.minutes')}` },
  {
    key: 4,
    part: `${t('page.mockTest.intro.part')} 2`,
    content: t('common.reading'),
    time: `29-30 ${t('page.mockTest.intro.minutes')}`,
  },
  { key: 5, time: `2 ${t('page.mockTest.intro.minutes')}` },
  {
    key: 6,
    part: `${t('page.mockTest.intro.part')} 3`,
    content: t('common.listening'),
    time: `30-43 ${t('page.mockTest.intro.minutes')}`,
  },
];

export const sectionTestData = (t: any): Record<string, { content: string; time?: string }[]> => ({
  Speaking: [
    { content: 'Read Aloud', time: `35 ${t('page.mockTest.intro.minutes')}` },
    { content: 'Repeat Sentence' },
    { content: 'Describe Image' },
    { content: 'Re-tell Lecture' },
    { content: 'Answer Short Question' },
  ],
  Writing: [
    { content: 'Read Aloud', time: `105 ${t('page.mockTest.intro.minutes')}` },
    { content: 'Summarize Written Text' },
    { content: 'Write Essay' },
    { content: 'Reading & Writing: Fill in the blanks' },
    { content: 'Summarize Spoken Text' },
    { content: 'Fill in the Blanks' },
    { content: 'Write From Dictation' },
  ],
  Reading: [
    { content: 'Read Aloud', time: `73 ${t('page.mockTest.intro.minutes')}` },
    { content: 'Summarize Written Text' },
    { content: 'Reading & Writing: Fill in the blanks' },
    { content: 'Reading: Multiple Choice (Multiple)' },
    { content: 'Re-order Paragraphs' },
    { content: 'Reading: Fill in the Blanks' },
    { content: 'Reading: Multiple Choice (Single)' },
    { content: 'Highlight Correct Summary' },
    { content: 'Highlight Incorrect Words' },
  ],
  Listening: [
    { content: 'Repeat Sentence', time: `63 ${t('page.mockTest.intro.minutes')}` },
    { content: 'Re-tell Lecture' },
    { content: 'Answer Short Question' },
    { content: 'Summarize Spoken Text' },
    { content: 'Listening: Multiple Choice (Multiple)' },
    { content: 'Listening: Fill in the Blanks' },
    { content: 'Highlight Correct Summary' },
    { content: 'Listening: Multiple Choice (Single)' },
    { content: 'Select Missing Word' },
    { content: 'Highlight Incorrect Words' },
    { content: 'Write From Dictation' },
  ],
});

export const timeSection = (type: string, t: TFunction) => {
  const timeMap: Record<string, number> = {
    FULL_TEST: 2,
    Speaking: 35,
    Writing: 105,
    Reading: 73,
    Listening: 63,
  };

  const minutes = timeMap[type] ?? 0;
  return `${minutes} ${
    type == MOCK_TEST_TYPE.FULL_TEST ? t('page.mockTest.intro.hour') : t('page.mockTest.intro.minutes')
  }`;
};
